import { createFileRoute, Navigate } from "@tanstack/react-router";

import MonitoringHubPage from "@/features/dashboard/pages/monitoring-hub";
import { isClientUser } from "@/features/dashboard/lib/access-control";
import { useAuth } from "@/providers/auth.provider";

function MonitoringRoute() {
  const { claims } = useAuth();

  if (isClientUser(claims)) {
    return <Navigate to="/dashboard/invoice-gate" replace />;
  }

  return <MonitoringHubPage />;
}

export const Route = createFileRoute("/(app)/dashboard/monitoring")({
  component: MonitoringRoute,
});
